import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import FacebookIcon from '../../../assets/icons/facebook.svg';
import TwitterIcon from '../../../assets/icons/twitter.svg';
import WhatsAppIcon from '../../../assets/icons/whatsapp.svg';
import ShareIcon from '../../../assets/icons/share.svg';
import Headline from '../../../ui/Headline';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import Button from '../../../ui/Button';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { useAppDispatch } from '../../../store';
import { copyTextToClipboard } from '../../../helpers';
import CopiedMessage from '../../../ui/CopiedMessage';
const ShareSocials = ({ shareUrl, points, minutes, rallyTitle }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [justCopied, setJustCopied] = useState(false);
    const shareText = `${rallyTitle} - ${points} ${t('label.points')} ${t('label.in')} ${minutes} ${t('placeholder.minutes').toLowerCase()}!!! Try comp@ss - `;
    const shareModalSocialItems = [
        {
            name: 'Facebook',
            icon: FacebookIcon,
            onClick: () => {
                const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
                window.open(facebookShareUrl, '_blank');
            },
        },
        {
            name: 'WhatsApp',
            icon: WhatsAppIcon,
            onClick: () => {
                const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText + shareUrl)}`;
                window.open(whatsappShareUrl, '_blank');
            },
        },
        {
            name: 'X',
            icon: TwitterIcon,
            onClick: () => {
                const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
                window.open(twitterUrl, '_blank');
            },
        },
    ];
    return (_jsxs("div", { className: 'modal-content share-socials', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.share_your_results'), type: 'h1' }) }), _jsxs("div", { className: "share-socials-content", children: [shareModalSocialItems.map(({ name, icon: Icon, onClick }, index) => (_jsxs("div", { className: 'share-socials-item', children: [_jsxs("span", { className: "share-socials-item-label", children: [_jsx("span", { children: _jsx(Icon, {}) }), _jsx("span", { children: `${t('label.share_on')} ${name}` })] }), _jsx(Button, { shape: "square", icon: _jsx(ShareIcon, {}), onClick: onClick })] }, index))), _jsx(Headline, { title: t('label.copy_rally_link'), type: 'h3' }), _jsxs("div", { className: 'share-socials-copy', children: [_jsx("div", { className: 'share-socials-copy-link', children: _jsx("span", { children: shareUrl }) }), _jsx("div", { className: 'share-socials-copy-btn link-button', onClick: () => copyTextToClipboard({ textToCopy: shareUrl, setJustCopied }), children: t('label.copy_link') }), _jsx("div", { className: `share-socials-copy-message`, children: _jsx(CopiedMessage, { justCopied: justCopied }) })] }), _jsx("div", { className: "modal-content-button", children: _jsx(ButtonsGroup, { justify: 'center', children: _jsx(Button, { variant: 'outlined', label: t('button.cancel'), onClick: () => {
                                    dispatch(setIsModalOpen(false));
                                    dispatch(setModalContent(null));
                                } }) }) })] })] }));
};
export default ShareSocials;
